import { api } from "./api";
import { track } from "./analytics";

/**
 * Add all 15 Season One drops to the user's Google Calendar in one click.
 * Tracks the intent, persists the preference (channel=google) then opens the
 * backend redirect endpoint in a new tab. Shared across the Home Notify Me
 * CTA, the Add-to-Calendar card and the PreLive page so behavior stays
 * identical.
 */
export async function addAllToGoogleCalendar(source) {
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  try { track("notify_calendar_click", { channel: "google", source }); } catch (_e) { /* noop */ }
  try { await api.post("/auth/me/notify", { calendar_subscribed: true, channel: "google" }); } catch (_e) { /* noop */ }
  window.open(`${backend}/api/calendar/google`, "_blank", "noopener,noreferrer");
}
